
import { FormFields } from "./FormFields";
import { WaitlistFormData } from "@/types/waitlist";

interface WaitlistFormFieldsProps {
  formData: WaitlistFormData;
  setFormData: (data: any) => void;
  isPro: boolean;
}

export const WaitlistFormFields = ({
  formData,
  setFormData,
  isPro,
}: WaitlistFormFieldsProps) => {
  return (
    <div className="space-y-4">
      <FormFields
        formData={formData}
        setFormData={setFormData}
        isPro={isPro}
      />
    </div>
  );
};
